import { put } from '../../base-portal-api';

import { MerchantPublicInformationUpdateRequest } from './types';

export function updateMerchantPublicInformation(data: MerchantPublicInformationUpdateRequest) {
  return put('v1/merchants/public-information', { json: data });
}
